import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import MerchantList from "../pages/Merchant/MerchantList";
import CreateMerchant from "../pages/Merchant/CreateMerchant";
import EditMerchant from "../pages/Merchant/EditMerchant";
//@ts-ignore
import {
  PermissionRequired,
  AccessControl,
} from "@careinfo/permission-required";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<MerchantList />} />
          <Route path="/merchant" element={<MerchantList />} />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateMerchant />}
                allowedPermissions={["can_create_merchant"]}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditMerchant />}
                allowedPermissions={["can_update_merchant"]}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
